import { Epic, ofType } from 'redux-observable';
import { mergeMap, switchMap } from 'rxjs/operators';
import { actions } from '.';
import { actions as worksheetActions } from '../WorksheetEditor';
import { of } from 'rxjs';
import { catchWithAuthErrors, addErrorNotice } from '../../Helpers/rxjsHelpers';
import { callApiAutoCreateLoadIncrements, callApiPutLoadIncrements } from './apiCalls';

export const initTempLoadIncrements: Epic = (action$, state$) =>
  action$.pipe(
    ofType(actions.initTempLoadIncrements.toString()),
    switchMap(() => {
      const loadIncrements = state$.value.worksheetEditor.syncModel.data.LoadIncrements;
      return of(
        actions.setTempLoadIncrements({
          loadIncrements,
        })
      );
    })
  );

export const autoCreateLoadIncrements: Epic = (action$, state$) =>
  action$.pipe(
    ofType(actions.autoCreateLoadIncrements.toString()),
    mergeMap(() =>
      callApiAutoCreateLoadIncrements(state$.value.worksheetEditor.worksheetId).pipe(
        mergeMap(({ LoadIncrements: loadIncrements }) =>
          of(
            actions.setTempLoadIncrements({
              loadIncrements,
            }),
            actions.autoCreateLoadIncrementsResolve()
          )
        ),
        catchWithAuthErrors((err: any) =>
          of(actions.autoCreateLoadIncrementsReject(), addErrorNotice('Failed to auto create load increments.', err))
        )
      )
    )
  );

export const triggerUpdate: Epic = (action$) =>
  action$.pipe(
    ofType(
      actions.setTempLoadIncrementValue.toString(),
      actions.addTempLoadIncrement.toString(),
      actions.removeTempLoadIncrement.toString()
    ),
    mergeMap(() => of(actions.updateLoadIncrements()))
  );

export const updateLoadIncrements: Epic = (action$, state$) =>
  action$.pipe(
    ofType(actions.updateLoadIncrements.toString()),
    switchMap(() => {
      return callApiPutLoadIncrements(
        state$.value.worksheetEditor.worksheetId,
        state$.value.plateLoading.loadIncrementsManagement.loadIncrements
      ).pipe(
        mergeMap(({ LoadIncrements: loadIncrements }) =>
          of(
            actions.setTempLoadIncrements({
              loadIncrements,
            }),
            actions.updateLoadIncrementsResolve()
          )
        ),
        catchWithAuthErrors((err: any) =>
          of(actions.updateLoadIncrementsReject(), addErrorNotice('Failed to update load increments data.', err))
        )
      );
    })
  );

export const applyTempLoadIncrementsToWorksheet: Epic = (action$, state$) =>
  action$.pipe(
    ofType(actions.applyTempLoadIncrementsToWorksheet.toString()),
    mergeMap(() => {
      const loadIncrements = state$.value.plateLoading.loadIncrementsManagement.loadIncrements;
      //Apply the temporary load increments to the worksheet state
      return of(worksheetActions.setValue({ name: 'data.LoadIncrements', value: loadIncrements, sync: true })).pipe(
        mergeMap(() => of(actions.applyTempLoadIncrementsToWorksheetResolve())),
        catchWithAuthErrors((err: any) =>
          of(
            actions.applyTempLoadIncrementsToWorksheetReject(),
            addErrorNotice('Failed to update load increments data.', err)
          )
        )
      );
    })
  );
